import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpDelete} from '../../../util/Rest';
import {AR} from '../../../constants/MicroServiceConstants';

const initialData = {
  debtorBatchData: {},
  debtorBatchStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'debtorBatch',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postDebtorBatchData: (state, action) => {
      state.debtorBatchStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    putDebtorBatchData: (state, action) => {
      state.debtorBatchStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    deleteDebtorBatchData: (state, action) => {
      state.debtorBatchStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetDebtorBatchStatus: (state) => {
      state.debtorBatchStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchError,
  postDebtorBatchData,
  putDebtorBatchData,
  deleteDebtorBatchData,
  resetDebtorBatchStatus,
  resetMsg,
} = slice.actions;

export const postDebtorBatch = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${AR}/save/debtorbatches`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postDebtorBatchData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const putDebtorBatch = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${AR}/update/debtorbatches`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(putDebtorBatchData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const deleteDebtorBatch = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpDelete(`${AR}/delete/cash/${details}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteDebtorBatchData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetDebtorBatchStatus());
  };
};
